import React from 'react';
import { Link } from 'react-router-dom';
import { bookInfo } from '../data/bookData';
import { FiBookOpen } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => (
  <footer className="bg-black py-12 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <SafeIcon icon={FiBookOpen} className="text-brand-accent text-xl" />
            <span className="font-display font-bold text-white tracking-wider text-sm uppercase">The Quantum Awakening</span>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed">
            A Chronicle of Humanity's Ascension by {bookInfo.author}
          </p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Navigate</h4>
          <div className="flex flex-col gap-2">
            {[
              ['Home', '/'],
              ['The Story', '/story'],
              ['The World of 2501', '/world'],
              ['The Lineages', '/lineages'],
              ['Read an Excerpt', '/excerpt'],
              ['Chapters', '/chapters'],
              ['FAQ', '/faq'],
              ['Author', '/author'],
            ].map(([name, href]) => (
              <Link key={name} to={href} className="text-gray-500 hover:text-brand-accent text-sm transition-colors">{name}</Link>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Get the Book</h4>
          <div className="flex flex-col gap-2">
            <a href={bookInfo.links.amazon.kindle} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-brand-accent text-sm transition-colors">Kindle Edition — $6.99</a>
            <a href={bookInfo.links.amazon.paperback} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-brand-accent text-sm transition-colors">Paperback — $17.99</a>
            <a href={bookInfo.links.amazon.hardcover} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-brand-accent text-sm transition-colors">Hardcover — $26.99</a>
            <a href={bookInfo.links.website.en} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-white text-sm transition-colors mt-2">Author Site (EN)</a>
            <a href={bookInfo.links.website.ro} target="_blank" rel="noreferrer" className="text-gray-500 hover:text-white text-sm transition-colors">Author Site (RO)</a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5 pt-8 text-center text-gray-600 text-sm">
        &copy;{new Date().getFullYear()} {bookInfo.author}. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;